export interface IFormModalRef {
    setModalOpen(value: boolean): void;
}

export const modalStyle = {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxHeight: '85vh',
    padding: '4.8rem',
    maxWidth: '70.4rem',
    overflow: 'auto',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    border: '',
};

export const focusCloseButton = () => {
    // Make sure modal animation is completed
    setTimeout(() => {
        document.getElementById('modal_close_button')?.focus();
    }, 50);
};

export const reactModalProps = {
    role: 'dialog',
    'aria-live': 'polite',
    shouldCloseOnOverlayClick: true,
    shouldCloseOnEsc: true,
    shouldFocusAfterRender: true,
    bodyOpenClassName: 'modal-open',
    style: {
        overlay: {
            zIndex: 11,
        },
        content: modalStyle,
    },
};
